import { useState } from 'react';
import { CairoEntityPageState, CairoEntityPageStateParams } from '../state';
import { useWixPatternsContainer } from '@wix/bex-core/react';

export function useCairoEntityPage(
  params: CairoEntityPageStateParams,
): CairoEntityPageState {
  useWixPatternsContainer(); // safety net to ensure that the container is initialized, for future use

  const [state] = useState(() => new CairoEntityPageState(params));

  return state;
}
